import { Package, Search, Bot, Tag, Instagram, Rocket } from "lucide-react";
import { SectionHead, Reveal } from "./Reveal";

const CARDS = [
  { n: "01", title: "Digital Product Basics", desc: "Understand digital products and business opportunities.", Icon: Package },
  { n: "02", title: "Niche & Idea Research", desc: "Find an audience and identify useful product ideas.", Icon: Search },
  { n: "03", title: "Create Products With AI", desc: "Learn ChatGPT and Canva product creation workflows.", Icon: Bot },
  { n: "04", title: "Pricing & Offers", desc: "Understand basic product pricing and positioning.", Icon: Tag },
  { n: "05", title: "Instagram Marketing", desc: "Learn how to create content that attracts potential customers.", Icon: Instagram },
  { n: "06", title: "Sales & Launch Basics", desc: "Understand landing pages, payment setup and basic sales processes.", Icon: Rocket },
];

export default function LearnGrid() {
  return (
    <section id="learn" data-testid="learn-section" className="bg-[#F6F1FF] py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <SectionHead
          eyebrow="What You'll Learn"
          title={<>Everything You Need to <span className="bg-gradient-to-r from-[#9B5CF0] to-[#6D28D9] bg-clip-text text-transparent">Get Started.</span></>}
          sub="A practical introduction to building and launching digital products with AI."
          testId="learn"
        />
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {CARDS.map((c, i) => (
            <Reveal key={c.n} delay={0.08 * i}>
              <div
                data-testid={`learn-card-${c.n}`}
                className="group h-full rounded-3xl border border-[#E9DFFC] bg-white p-7 shadow-[0_10px_30px_-15px_rgba(28,16,45,0.08)] transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1.5 hover:border-[#7C3AED]/40 hover:shadow-[0_25px_50px_-20px_rgba(124,58,237,0.25)]"
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[#F6F1FF] text-[#7C3AED] transition-colors duration-300 group-hover:bg-gradient-to-br group-hover:from-[#9B5CF0] group-hover:to-[#6D28D9] group-hover:text-white">
                    <c.Icon size={20} strokeWidth={2.2} />
                  </span>
                  <span className="font-mono text-xs font-bold tracking-[0.2em] text-[#C9B8F5]">{c.n}</span>
                </div>
                <h3 className="mt-5 text-lg font-extrabold tracking-tight text-[#171321]">{c.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#777181]">{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
